module.exports = {
  type: {
    CONTENT: 'content',
    GUIDE: 'guide',
  },
  settingCategories: [
    { id: 'user-customization', title: 'User Customization' },
  ],
}
